import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';


export function* initTopologySaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const techMobile = yield sessionStorage.getItem('techMobile');
  const handleTopology = yield sessionStorage.getItem('handleTopology');
  let days;
  if(handleTopology){
    if(techMobile && (techMobile === true || techMobile === 'true')) {
      if(handleTopology.includes('default7TM')){
        days = 7
      } else if(handleTopology.includes('default30TM')){
        days = 30
      }else {
        days = 1
      }
    } else {
      if(handleTopology.includes('default7GW')){
        days = 7
      } else if(handleTopology.includes('default30GW')){
        days = 30
      }else {
        days = 1
      }
    }
  }else{
    days = 1
  }
  if(action && action.days && (action.days === 1 || action.days === 7 || action.days === 30)){
    days = action.days
  } else {
    days = 1
  }

  // let days = action.days ? action.days : 1;
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    yield put(actions.initTopologyStart(days));
    try {
      let response = {};
      var nowTime = new Date();
      response = yield axios.post(
        '/topology',
        {
          rMac: rMac || '',
          days: days,
          endAt: nowTime,
          bToken: token,
          sessionToken: sessionToken
        }
      ).then(res => {
        if(res.data.status === 200){
          return res.data.topology
        }else {
          return null
        }
        //When res.data.topology is empty array, JSON.parse method throws an error. To avoid that, below condition is used

      })
      //console.log('TOPO RESPONSE', response)
      yield put(actions.setTopology(response));

    } catch (error) {
      console.error('sagas.topology error:', error);
      yield put(actions.fetchTopologyFailed());
    }
  } else {
    //console.log('NO TOKEN')
  }

}





